import NotificationServices from "../../services/externalServices/notification/NotificationServices";

export const sendNotificationBidRequest = async ({
    cabRequestId,
    fcmTokens,
    phoneNumbers,
    authUser = {},
    selectedPackage = {},
    selectedDate = '',
    selectedTime = '',
    pickupLocation = {},
    serviceAssociated = '',
    acType='',
    setIsSendingNotifications = () => { },
}) => {

    console.log('Sending notification through sendNotificationBidRequest');

    setIsSendingNotifications(true);

    console.log(`sendNotificationBidRequest -> cabRequestId `, cabRequestId);
    console.log(`sendNotificationBidRequest -> fcmTokens `, fcmTokens);
    console.log(`sendNotificationBidRequest -> phoneNumbers `, phoneNumbers);

    try {
        // Ensure necessary data is valid before proceeding
        if (!cabRequestId || !Array.isArray(fcmTokens) || fcmTokens.length === 0) {
            console.warn('Invalid cabRequestId or FCM tokens. Skipping notification.');
            return;
        }

        if (!fcmTokens || fcmTokens.length === 0) {
            console.warn('Please provide at least one FCM token');
            return;
        }

        if (!phoneNumbers || phoneNumbers.length === 0) {
            console.warn('Please provide at least one target phone number');
            return;
        }

        if (fcmTokens.length !== phoneNumbers.length) {
            console.warn('The number of FCM tokens and target phone numbers must match');
            return;
        }

        const notificationData = {
            cabRequestId: cabRequestId,
            name: authUser?.first_name || 'Unknown',
            selectedPackageName: selectedPackage?.detailTitle || '',
            selectedDate: selectedDate?.toString() || '',
            selectedTime: selectedTime?.toString() || '',
            selectedPackageThumbnail: selectedPackage?.thumbnailImage || '',
            pickup_location: pickupLocation?.title || 'Unknown location',
            drop_location: pickupLocation?.title || 'Unknown location',
            serviceAssociated: serviceAssociated || 'Unknown service',
            selectedPackage: selectedPackage?._id?.toString() || '',
            acType:acType
        };

        const data = {
            triggeredByApp: 'user',
            fcmTokens: fcmTokens,
            phoneNumbers: phoneNumbers,
            serviceType: 'TourPackage',
            notificationType: 'bidRequest',
            title: 'Bid Request',
            notificationData: notificationData,
        };

        console.log('Sending notification with data:', JSON.stringify(data, null, 2));

        const notificationResponse=await NotificationServices.notificationStoreAndSend(data);
        console.log("notificationResponse",notificationResponse);
    } catch (err) {
        console.error('Error occurred while sending notification:', err);
    } finally {
        setIsSendingNotifications(false);
        console.log('Sending notification process completed.');
    }
};


export const sendNotificationBidNotAccepted = async ({
    cabRequestId,
    fcmTokens,
    phoneNumbers,
    authUser = {},
    selectedPackage = {},
    setIsSendingNotifications = () => { },
}) => {

    console.log('Sending notification through sendNotificationBidNotAccepted');
    console.log('cabRequestId fcmTokens.length phoneNumbers.length', fcmTokens, phoneNumbers);


    setIsSendingNotifications(true);

    try {
        // Ensure necessary data is valid before proceeding
        if (!Array.isArray(fcmTokens) || fcmTokens.length === 0) {
            console.warn('Invalid FCM tokens. Skipping notification.');
            return;
        }
        // if (!cabRequestId || !Array.isArray(fcmTokens) || fcmTokens.length === 0) {
        //     console.warn('Invalid cabRequestId or FCM tokens. Skipping notification.');
        //     return;
        // }

        if (!fcmTokens || fcmTokens.length === 0) {
            console.warn('Please provide at least one FCM token');
            return;
        }

        if (!phoneNumbers || phoneNumbers.length === 0) {
            console.warn('Please provide at least one target phone number');
            return;
        }

        if (fcmTokens.length !== phoneNumbers.length) {
            console.warn('The number of FCM tokens and target phone numbers must match');
            return;
        }

        const notificationData = {
            cabRequestId: cabRequestId,
            name: authUser?.first_name || 'Unknown',
            selectedPackageName: selectedPackage?.detailTitle || '',
        };

        const data = {
            triggeredByApp: 'user',
            fcmTokens: fcmTokens,
            phoneNumbers: phoneNumbers,
            serviceType: 'TourPackage',
            notificationType: 'bidNotAccepted',
            title: 'Bid not accepted',
            notificationData: notificationData,
        };

        console.log('Sending notification with data:', JSON.stringify(data, null, 2));

        await NotificationServices.notificationStoreAndSend(data);
    } catch (err) {
        console.error('Error occurred while sending notification:', err);
    } finally {
        setIsSendingNotifications(false);
        console.log('Sending notification process completed.');
    }
};

export const sendNotificationBidAccepted = async ({
    cabRequestId,
    fcmTokens,
    phoneNumbers,
    authUser = {},
    selectedPackage = {},
    setIsSendingNotifications = () => { },
}) => {

    console.log('Sending notification through sendNotificationBidAccepted');
    console.log('cabRequestId fcmTokens.length phoneNumbers.length', fcmTokens, phoneNumbers);


    setIsSendingNotifications(true);

    try {
        // Ensure necessary data is valid before proceeding
        if (!Array.isArray(fcmTokens) || fcmTokens.length === 0) {
            console.warn('Invalid FCM tokens. Skipping notification.');
            return;
        }
        // if (!cabRequestId || !Array.isArray(fcmTokens) || fcmTokens.length === 0) {
        //     console.warn('Invalid cabRequestId or FCM tokens. Skipping notification.');
        //     return;
        // }

        if (!fcmTokens || fcmTokens.length === 0) {
            console.warn('Please provide at least one FCM token');
            return;
        }

        if (!phoneNumbers || phoneNumbers.length === 0) {
            console.warn('Please provide at least one target phone number');
            return;
        }

        if (fcmTokens.length !== phoneNumbers.length) {
            console.warn('The number of FCM tokens and target phone numbers must match');
            return;
        }

        const notificationData = {
            cabRequestId: cabRequestId,
            name: authUser?.first_name || 'Unknown',
            selectedPackageName: selectedPackage?.detailTitle || '',
        };

        const data = {
            triggeredByApp: 'user',
            fcmTokens: fcmTokens,
            phoneNumbers: phoneNumbers,
            serviceType: 'TourPackage',
            notificationType: 'bidAccepted',
            title: 'Bid Accepted',
            notificationData: notificationData,
        };

        console.log('Sending notification with data:', JSON.stringify(data, null, 2));

        await NotificationServices.notificationStoreAndSend(data);
    } catch (err) {
        console.error('Error occurred while sending notification:', err);
    } finally {
        setIsSendingNotifications(false);
        console.log('Sending notification process completed.');
    }
};

export const sendNotificationTripConfirmed = async ({
    fcmTokens,
    phoneNumbers,
    // authUser = {},
    packageName,
    selectedDate,
    selectedTime,
}) => {

    console.log('Sending notification through sendNotificationBidNotAccepted');

    try {
        // Ensure necessary data is valid before proceeding
        if (!Array.isArray(fcmTokens) || fcmTokens.length === 0) {
            console.warn('Invalid cabRequestId or FCM tokens. Skipping notification.');
            return;
        }

        if (!fcmTokens || fcmTokens.length === 0) {
            console.warn('Please provide at least one FCM token');
            return;
        }

        if (!phoneNumbers || phoneNumbers.length === 0) {
            console.warn('Please provide at least one target phone number');
            return;
        }

        if (fcmTokens.length !== phoneNumbers.length) {
            console.warn('The number of FCM tokens and target phone numbers must match');
            return;
        }

        const notificationData = {
            // name: authUser?.first_name || 'Unknown',
            name: '',
            selectedPackageName: packageName || '',
            selectedDate: selectedDate,
            selectedTime: selectedTime,
        };

        const data = {
            triggeredByApp: 'user',
            fcmTokens: fcmTokens,
            phoneNumbers: phoneNumbers,
            serviceType: 'TourPackage',
            notificationType: 'tripConfirmed',
            title: 'Hurray, You have got a trip!',
            notificationData: notificationData,
        };

        console.log('Sending notification with data:', JSON.stringify(data, null, 2));

        await NotificationServices.notificationStoreAndSend(data);
    } catch (err) {
        console.error('Error occurred while sending notification:', err);
    } finally {

        console.log('Sending notification process completed.');
    }
};

export const sendNotificationPaymentNotAccepted = async ({
    cabRequestId,
    fcmTokens,
    phoneNumbers,
    authUser = {},
    selectedPackage = {},
    setIsSendingNotifications = () => { },
}) => {

    console.log('Sending notification through sendNotificationApymentNotAccepted');
    console.log('payment === cabRequestId fcmTokens.length phoneNumbers.length', fcmTokens, phoneNumbers);


    setIsSendingNotifications(true);

    try {
        // Ensure necessary data is valid before proceeding
        if (!Array.isArray(fcmTokens) || fcmTokens.length === 0) {
            console.warn('Invalid FCM tokens. Skipping notification.');
            return;
        }
        // if (!cabRequestId || !Array.isArray(fcmTokens) || fcmTokens.length === 0) {
        //     console.warn('Invalid cabRequestId or FCM tokens. Skipping notification.');
        //     return;
        // }

        if (!fcmTokens || fcmTokens.length === 0) {
            console.warn('Please provide at least one FCM token');
            return;
        }

        if (!phoneNumbers || phoneNumbers.length === 0) {
            console.warn('Please provide at least one target phone number');
            return;
        }

        if (fcmTokens.length !== phoneNumbers.length) {
            console.warn('The number of FCM tokens and target phone numbers must match');
            return;
        }

        const notificationData = {
            cabRequestId: cabRequestId,
            name: authUser?.first_name || 'Unknown',
            selectedPackageName: selectedPackage?.detailTitle || '',
        };

        const data = {
            triggeredByApp: 'user',
            fcmTokens: fcmTokens,
            phoneNumbers: phoneNumbers,
            serviceType: 'TourPackage',
            notificationType: 'paymentNotAccepted',
            title: 'Payment not accepted',
            notificationData: notificationData,
        };

        console.log('Sending notification with data in paymnet:', JSON.stringify(data, null, 2));

        await NotificationServices.notificationStoreAndSend(data);
    } catch (err) {
        console.error('Error occurred while sending notification:', err);
    } finally {
        setIsSendingNotifications(false);
        console.log('Sending notification process completed.');
    }
};

export const sendNotificationBidRequestAuto = async ({
    cabRequestId,
    fcmTokens,
    phoneNumbers,
    authUser = {},
    selectedPackage = {},
    selectedDate = '',
    selectedTime = '',
    pickupLocation = {},
    dropLocation = {},
    serviceAssociated = '',
    setIsSendingNotifications = () => { },
}) => {

    console.log('Sending notification through sendNotificationBidRequest');

    setIsSendingNotifications(true);

    console.log(`sendNotificationBidRequest -> cabRequestId `, cabRequestId);
    console.log(`sendNotificationBidRequest -> fcmTokens `, fcmTokens);
    console.log(`sendNotificationBidRequest -> phoneNumbers `, phoneNumbers);

    try {
        // Ensure necessary data is valid before proceeding
        if (!cabRequestId || !Array.isArray(fcmTokens) || fcmTokens.length === 0) {
            console.warn('Invalid cabRequestId or FCM tokens. Skipping notification.');
            return;
        }

        if (!fcmTokens || fcmTokens.length === 0) {
            console.warn('Please provide at least one FCM token');
            return;
        }

        if (!phoneNumbers || phoneNumbers.length === 0) {
            console.warn('Please provide at least one target phone number');
            return;
        }

        if (fcmTokens.length !== phoneNumbers.length) {
            console.warn('The number of FCM tokens and target phone numbers must match');
            return;
        }

        const notificationData = {
            cabRequestId: cabRequestId,
            name: authUser?.first_name || 'Unknown',
            selectedPackageName: selectedPackage?.detailTitle || '',
            selectedDate: selectedDate?.toString() || '',
            selectedTime: selectedTime?.toString() || '',
            selectedPackageThumbnail: selectedPackage?.thumbnailImage || '',
            pickup_location: pickupLocation?.title || 'Unknown location',
            drop_location: dropLocation?.title || 'Unknown location',
            serviceAssociated: serviceAssociated || 'Unknown service',
            selectedPackage: selectedPackage?._id?.toString() || '',
        };

        const data = {
            triggeredByApp: 'user',
            fcmTokens: fcmTokens,
            phoneNumbers: phoneNumbers,
            serviceType: 'Auto',
            notificationType: 'bidRequest',
            title: 'Bid Request',
            notificationData: notificationData,
        };

        console.log('Sending notification with data:', JSON.stringify(data, null, 2));

        await NotificationServices.notificationStoreAndSend(data);
    } catch (err) {
        console.error('Error occurred while sending notification:', err);
    } finally {
        setIsSendingNotifications(false);
        console.log('Sending notification process completed.');
    }
};
